module.exports = __webpack_public_path__ + "media/sample-12s.7cb1f57f.mp3";